var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12463 3.52884C6.12463 3.87759 6.218 4.18246 6.42838 4.44459H4.81175C4.73527 4.16611 4.69779 3.87836 4.70038 3.58959C4.70038 1.75921 6.31588 0.475586 8.61537 0.475586C10.8305 0.475586 12.4291 1.79746 12.491 3.68184H11.1073C10.9835 2.46684 10.0227 1.72096 8.576 1.72096C7.19225 1.72096 6.1235 2.39821 6.1235 3.52884H6.12463ZM8.59288 11.9416C6.17075 11.9416 4.55525 10.6962 4.42475 8.78034H5.8085C5.9705 9.97283 7.07862 10.6962 8.6705 10.6962C10.178 10.6962 11.2692 9.90308 11.2692 8.81184C11.2692 7.88146 10.6539 7.26608 9.116 6.92746L8.05175 6.69459H0.125V5.56959H15.875V6.69459H11.933C12.4595 7.18621 12.6924 7.81283 12.6924 8.60371C12.6924 10.658 11.0769 11.9416 8.59288 11.9416Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleLine);
export default __webpack_public_path__ + "static/media/MiddleLine.aeb4a118ba2ee70b304b061a91e0e950.svg";
export { ForwardRef as ReactComponent };